'use client';

import { Link } from '@packages/modules/src/Link/Link';
import { useTrackMarketing } from '@packages/shared/src/hooks/useTrackCampaign/useTrackCampaign';
import { type ReactNode, type RefObject } from 'react';
import { useAssignLinkTargetBasedOnBotStatus } from '../../../hooks/useAssignLinkTargetBasedOnBotStatus';
import { buildLinkWithArguments } from '../../../utils/buildLinkWithArguments';
import type { HeadlineType } from '../types';

export const LinkWrapper = ({
  data,
  headlineRef,
}: {
  data: HeadlineType;
  headlineRef: RefObject<HTMLDivElement | null>;
}) => {
  const {
    field_link: fieldLink,
    field_link_title: linkTitle,
    field_link_target: linkTarget = '_self',
    behavior_paragraph_link_rel: linkRelRaw,
  } = data;
  const linkRel = linkRelRaw === '_none' ? undefined : linkRelRaw;

  const tmpLink = buildLinkWithArguments(fieldLink, data);
  const assignLinkTarget = useAssignLinkTargetBasedOnBotStatus();
  const finalLink = assignLinkTarget(tmpLink);
  const { trackClick } = useTrackMarketing(data, headlineRef, finalLink);
  return (children: ReactNode) => (
    <Link
      href={finalLink}
      {...(linkTarget && { target: linkTarget })}
      {...(linkTarget === '_blank' && { rel: 'noopener' })}
      rel={linkRel}
      title={linkTitle || ''}
      color="inherit" // no highlight color
      onClick={() => trackClick()}
    >
      {children}
    </Link>
  );
};
